var eventTracker = require('mode-front-end/resources/assets/js/analytics/trackEvent');
var map = require('mode-front-end/resources/assets/js/array/map');
require('./gascrolldepth.custom');

const DEBUG = false;

export default (function() {

  /**
   * Virtual Page View Google Analytics event tracker.
   * @type {Function}
   */
  var trackVirtualPageview = eventTracker.create({
    'event': 'GAVirtualPageview',
    'eventNonInteraction': true,
    'debug': DEBUG
  });

  /**
   * Standard Google Analytics event tracker.
   * @type {Function}
   */
  var trackEvent = eventTracker.create({
    'event': 'GAEvent',
    'eventNonInteraction': false,
    'debug': DEBUG
  });

  /**
   * Track Google Analytics event with configurable params and access to
   * helper methods.
   * @param  {Event}  e
   * @return {Boolean}
   */
  function trackGaEvent(data) {
    if (!data.eventCategory) {
      return false;
    }

    var params = {
      // Required
      'eventCategory': data.eventCategory,
      // Optional
      'eventAction': data.eventAction || null,
      'eventLabel': data.eventLabel || null,
      'eventValue': data.eventValue || null
    };

    trackEvent(params);

    return true;
  }

  /**
   * Track click event for specified elements. Use the element's text as the
   * default eventLabel. Allow custom overrides.
   * @param  {Event}  e
   * @return {Boolean}
   */
  function trackGaClickEvent(e) {
    var data = JSON.parse(this.getAttribute('data-ga-click-event') || {});

    data.element = this;

    return trackGaEvent(data);
  }

  function trackGaHoverEvent(e) {
    var data = JSON.parse(this.getAttribute('data-ga-hover-event') || {});

    data.element = this;
    return trackGaEvent(data);
  }

  /**
   * Setup default event handlers.
   * @return {void}
   */
  function init(scrollElements) {
    // Click events
    map(document.querySelectorAll('[data-ga-click-event]'), function(el, index) {
      el.addEventListener('click', trackGaClickEvent);
    });

    // "hover" events
    map(document.querySelectorAll('[data-ga-hover-event]'), function(el, index) {
      el.addEventListener('mouseenter', trackGaHoverEvent);
    });

    gascrolldepth.reset()

    // Scroll %
    gascrolldepth.init({
      minHeight: 0,
      elements: scrollElements || [],
      percentage: true,
      percentageMarks: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      userTiming: false,
      pixelDepth: false,
      nonInteraction: true
      // DEBUG
      // eventHandler: function(data) {
      //   console.log(data);
      // }
    });
  }

  // ------------------------------
  // Public
  // ------------------------------

  var analytics = {
    init: init,
    trackEvent: trackEvent,
    trackGaEvent: trackGaEvent,
    trackVirtualPageview: trackVirtualPageview
  };

  return analytics;

})();
